import Vue from "vue";
import Vuex from "vuex";

import roles from "./modules/roles";
import usuarios from "./modules/usuarios";
import avls from "./modules/avls";
import chips from "./modules/chips";
import clientes from "@/store/modules/clientes";
import cuentas from "@/store/modules/cuentas";
import ubicacionDinero from "@/store/modules/ubicacionDinero";
import Permissions from "@/store/modules/Permissions";
import Suspensiones from "@/store/modules/Suspensiones";
import Movimientos from "./modules/Caja/Movimientos";
import empresas from "@/store/modules/Empresas";
import Contratos from "@/store/modules/Contratos/Contratos";
import EmpresasPropias from "@/store/modules/EmpresasPropias/EmpresasPropias";
import AccesoTesteo from "@/store/modules/AccesoTesteo";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {},
  modules: {
    roles: {
      namespaced: true,
      ...roles,
    },
    permissions: {
      namespaced: true,
      ...Permissions,
    },
    usuarios: {
      namespaced: true,
      ...usuarios,
    },
    avls: {
      namespaced: true,
      ...avls,
    },
    chips: {
      namespaced: true,
      ...chips,
    },
    clientes: {
      namespaced: true,
      ...clientes,
    },
    EmpresasPropias: {
      ...EmpresasPropias,
    },
    Empresas: {
      namespaced: true,
      ...empresas,
    },
    Contratos: {
      namespaced: true,
      ...Contratos,
    },
    AccesoTesteo: {
      namespaced: true,
      ...AccesoTesteo,
    },
    cuentas: {
      namespaced: true,
      ...cuentas,
    },
    ubicacionDinero: {
      namespaced: true,
      ...ubicacionDinero,
    },
    Suspensiones: {
      namespaced: true,
      ...Suspensiones,
    },
    Movimientos,
  },
});

export default store;
